import {Component, Input} from '@angular/core';
import {MenuItemModel} from '../../models/menu-item.model';

@Component({
  selector: 'app-page-menu',
  templateUrl: './page-menu.component.html',
  styleUrls: ['./page-menu.component.scss']
})
export class PageMenuComponent {
  @Input() menuList: MenuItemModel[];

  isActive(link: string): string {
    return window.location.pathname.includes('/' + link + '/') ? 'active' : '';
  }

  get hasChildren() {
    return this.menuList.filter(menu => menu.children && menu.children.length > 0).length > 0;
  }
}
